import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiPrinter } from 'react-icons/fi';

const DakhlUtarePrintReport = () => {
    const navigate = useNavigate();

    // Mock Data based on the image
    const reportData = [
        {
            type: "नमुना ८ (व्यक्तिगत)",
            entries: [
                { srNo: 1, date: "01/04/2025", outwardNo: "12", moneyTaken: "होय", amount: 0 },
                { srNo: 2, date: "01/04/2025", outwardNo: "12", moneyTaken: "होय", amount: 20 },
            ]
        },
        {
            type: "जन्माचा दाखला",
            entries: [
                { srNo: 1, date: "01/04/2025", outwardNo: "12", moneyTaken: "होय", amount: 20 },
                { srNo: 2, date: "01/04/2025", outwardNo: "12", moneyTaken: "होय", amount: 12 },
            ]
        },
        {
            type: "उत्पन्नाचा दाखला",
            entries: [
                { srNo: 1, date: "01/04/2025", outwardNo: "1", moneyTaken: "होय", amount: 100 },
            ]
        },
        {
            type: "निराधार योजनेसाठी वयाचा दाखला",
            entries: [
                { srNo: 1, date: "01/04/2025", outwardNo: "12", moneyTaken: "होय", amount: 10 },
            ]
        }
    ];

    // Calculate Grand Total
    const grandTotal = reportData.reduce((total, group) => {
        return total + group.entries.reduce((groupTotal, entry) => groupTotal + entry.amount, 0);
    }, 0);

    useEffect(() => {
        // Auto-trigger print
        const timer = setTimeout(() => {
            window.print();
        }, 500); 
        return () => clearTimeout(timer);
    }, []);

    const handlePrint = () => {
        window.print();
    };

    return (
        <div className="min-h-screen bg-white p-4 md:p-8 font-poppins text-gray-900">
             {/* No-Print Header */}
             <div className="max-w-[210mm] mx-auto mb-6 flex justify-between items-center print:hidden">
                <button 
                    onClick={() => navigate(-1)}
                    className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700 flex items-center gap-2"
                >
                    <FiArrowLeft /> मागे जा
                </button>
                <button 
                    onClick={handlePrint}
                    className="px-4 py-2 bg-[#267c77] text-white rounded hover:bg-[#1e6b66] flex items-center gap-2"
                >
                    <FiPrinter /> प्रिंट करा
                </button>
            </div>

            {/* Printable Content */}
            <div className="max-w-[210mm] mx-auto print:w-full print:max-w-none">
                <div className="text-center mb-6">
                    <h2 className="text-xl font-bold">ग्रामपंचायत इनाम धामणी ता. मिरज जि. सांगली</h2>
                    <h3 className="text-lg font-bold mt-2">दाखले उतारे सर्व प्रकार</h3>
                </div>

                <div className="flex justify-between font-medium mb-4 text-sm">
                    <div>दिनांक 01/04/2025 ते 01/04/2025</div>
                    <div>दिनांक :- 01/04/2025</div>
                </div>

                <table className="w-full border-collapse border border-black text-sm">
                    <thead>
                        <tr className="bg-transparent">
                            <th className="border border-black p-2 w-12 text-center">अ.क्र.</th>
                            <th className="border border-black p-2 w-24 text-center">दिनांक</th>
                            <th className="border border-black p-2 w-20 text-center">जावक क्र.</th>
                            <th className="border border-black p-2 text-center">रिपोर्टचे नाव</th>
                            <th className="border border-black p-2 w-24 text-center">पैसे घेतले का?</th>
                            <th className="border border-black p-2 w-24 text-center">मिळालेली रक्कम</th>
                        </tr>
                    </thead>
                    <tbody>
                        {reportData.map((group, groupIndex) => {
                             const groupTotal = group.entries.reduce((sum, entry) => sum + entry.amount, 0);
                             
                             return (
                                <React.Fragment key={groupIndex}>
                                    {group.entries.map((entry, entryIndex) => (
                                        <tr key={`${groupIndex}-${entryIndex}`}>
                                            <td className="border-l border-r border-black p-2 text-center">{entry.srNo}</td>
                                            <td className="border-r border-black p-2 text-center">{entry.date}</td>
                                            <td className="border-r border-black p-2 text-center">{entry.outwardNo}</td>
                                            
                                            {/* Report Name - Only show for first entry, but don't use rowspan to strictly match the visual which might imply "Grouping Header" behavior or just blank cells. 
                                                Looking at image, "Namuna 8" is at the top of its block. Let's put it in the first row. 
                                            */}
                                            <td className="border-r border-black p-2 pl-4 align-top">
                                                {entryIndex === 0 ? <span className="font-semibold">{group.type}</span> : ""}
                                            </td>

                                            <td className="border-r border-black p-2 text-right">{entry.moneyTaken}</td>
                                            <td className="border-r border-black p-2 text-center">{entry.amount}</td>
                                        </tr>
                                    ))}
                                    {/* Group Subtotal Row */}
                                    <tr className="border-b border-black">
                                        <td className="border-l border-r border-black p-2"></td>
                                        <td className="border-r border-black p-2"></td>
                                        <td className="border-r border-black p-2"></td>
                                        <td className="border-r border-black p-2"></td>
                                        <td className="border-r border-black p-2 text-right font-bold">एकुण</td>
                                        <td className="border-r border-black p-2 text-center font-bold">{groupTotal}</td>
                                    </tr>
                                </React.Fragment>
                             );
                        })}
                        
                        {/* Grand Total Row */}
                         <tr>
                            <td className="border border-black p-2"></td>
                            <td className="border border-black p-2"></td>
                            <td className="border border-black p-2"></td>
                            <td className="border border-black p-2"></td>
                            <td className="border border-black p-2 text-right font-bold">एकुण</td>
                            <td className="border border-black p-2 text-center font-bold text-lg">{grandTotal}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
             <style type="text/css" media="print">
                {`
                    @page { 
                        size: portrait; 
                        margin: 15mm; 
                    }
                    body { 
                        background: white; 
                    }
                    .print\\:hidden { 
                        display: none !important; 
                    }
                    .print\\:w-full { 
                        width: 100% !important; 
                    }
                    .print\\:max-w-none {
                        max-width: none !important;
                    }
                `}
            </style>
        </div>
    );
};

export default DakhlUtarePrintReport;
